<template>
    <div class="content_box">
        <div class="content">
            <div class="top">
                <div class="title">
                    <span>用户详情</span>
                </div>
            </div>
            <div class="user">
                <div class="header">
                    <el-descriptions class="user_info" :column="4">
                        <el-descriptions-item label="用户账号">{{ baseInfo.acctname }}</el-descriptions-item>
                        <el-descriptions-item label="用户名">{{ baseInfo.username }}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ formDate(baseInfo.create_time) }}</el-descriptions-item>
                        <el-descriptions-item label="最后活跃时间">{{ formDate(baseInfo.last_time) }}</el-descriptions-item>
                        <el-descriptions-item label="所属区域">
                            <div v-if="baseInfo.region == 'cn'">中国区</div>
                            <div v-if="baseInfo.region == 'eu'">欧洲区</div>
                            <div v-if="baseInfo.region == 'us'">美洲区</div>
                            <div v-if="baseInfo.region == 'ap'">亚太区</div>
                            <div v-if="baseInfo.region == 'dev'">开发环境</div>
                            <div v-if="baseInfo.region == 'test'">测试环境</div>
                            <span>{{ `（${baseInfo.area_code}）` }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label="国家/地区">{{ baseInfo.country && baseInfo.country != '0' ?
                        baseInfo.country : '--'}}</el-descriptions-item>
                        <el-descriptions-item label="省份/州">{{ baseInfo.province || '--' }}</el-descriptions-item>
                        <el-descriptions-item label="城市">{{ baseInfo.city || '--' }}</el-descriptions-item>
                    </el-descriptions>
                </div>
                <div class="main">
                    <template>
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="登录信息" name="first">
                                <el-descriptions class="login_info" :column="3">
                                    <el-descriptions-item label="identityId">{{ baseInfo.ali_identity_id }}</el-descriptions-item>
                                    <el-descriptions-item label="阿里openId">{{ baseInfo.ali_open_id }}</el-descriptions-item>
                                    <el-descriptions-item label="区域">{{ baseInfo.ali_region }}</el-descriptions-item>
                                    <el-descriptions-item label="推送类别">
                                        <span v-if="baseInfo.push_type == 0"> -- </span>
                                        <span v-if="baseInfo.push_type == 1">极光</span>
                                        <span v-if="baseInfo.push_type == 2">FCM</span>
                                        <span v-if="baseInfo.push_type == 3">APNS</span>
                                    </el-descriptions-item>
                                    <el-descriptions-item label="推送Token">{{ baseInfo.push_token || '--' }}</el-descriptions-item>
                                    
                                </el-descriptions>
                                <br>
                                <p class="font_size">登录记录</p>
                                <el-table :data="loginInfo" :fit="true" highlight-current-row style="width:100%">
                                    <el-table-column prop="login_ip" label="登录IP" width="200"></el-table-column>
                                    <el-table-column prop="device_number" label="登录设备信息" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.device_number || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="dev_sys_ver" label="登录设备系统版本号" width="300">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.dev_sys_ver || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="AppVersion" label="登录APP版本号" width="300">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.AppVersion || '--' }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="create_time" label="登录时间" width="160">
                                        <template slot-scope="scope">
                                            <span>{{ formDate(scope.row.create_time) }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <Pagination :total="loginTotal" :page="loginSearch.page"
                                    @paginationChange="paginationChange1" class="pagination">
                                </Pagination>
                            </el-tab-pane>
                            <el-tab-pane label="绑定设备信息" name="second">
                                <el-table :data="deviceInfo.slice((currentPage - 1) * PageSize, currentPage * PageSize)"
                                    :fit="true" highlight-current-row style="width:100%">
                                    <el-table-column prop="deviceName" label="DeviceName" width="200"
                                        show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <div class="btn">
                                                <div class="button text" @click.stop="goDetail(scope.row)">
                                                    <span>{{scope.row.deviceName}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="productKey" label="ProductKey" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="productName" label="产品名称" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="owned" label="用户身份" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.owned == 1">主用户</span>
                                            <span v-if="scope.row.owned == 0">用户</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="bindTime" label="绑定时间" width="160">
                                        <template slot-scope="scope">
                                            <span>{{ formDate(scope.row.bindTime) }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="act" label="操作" width="200">
                                        <template slot-scope="scope">
                                            <div class="btn" v-if="roleCheck('104-101-101-102')">
                                                <div class="button text" @click="unboundConfirm(scope.row.iotId)">
                                                    <span>解绑</span>
                                                </div>
                                            </div>
                                            <span v-else>--</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-tab-pane>
                            <el-tab-pane label="三方信息" name="third">
                                <el-descriptions class="login_info" :column="3">
                                    <el-descriptions-item label="微信关联Neakasa账号ID">{{ thridData.user_id || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="微信APPID">{{ thridData.appid || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="微信openid">{{ thridData.openid || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="微信unionid">{{ thridData.unionid || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="苹果账号ID">{{ thridData.apple_user_id || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="苹果账号邮箱">{{ thridData.apple_email || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="Google账号ID">{{ thridData.google_user_id || '--'}}</el-descriptions-item>
                                    <el-descriptions-item label="Google账号邮箱">{{ thridData.google_email || '--'}}</el-descriptions-item>
                                </el-descriptions>
                            </el-tab-pane>
                        </el-tabs>
                    </template>
                </div>
                <Tip ref="Tip" msg="确定要解绑设备吗，解绑后不能再恢复哦！" title="解绑设备">
                    <template v-slot:confirm_btn>
                        <div class="button del" @click="unbound">
                            <span>确定</span>
                        </div>
                    </template>
                </Tip>
            </div>

        </div>
    </div>
</template>
<script>
export default ({
    name: 'user-detail',
    data() {
        return {
            activeName: 'first',
            ali_user_id: '',
            baseInfo: [],
            loginInfo: [],
            loginTotal: 0,
            deviceInfo: [],
            // 总数据
            tableData: [],
            // 默认显示第几页
            currentPage: 1,
            // 总条数
            deviceTotal: 0,
            // 个数选择器（可修改）
            pageSizes: [5, 10, 15, 20],
            // 默认每页显示的条数（可修改）
            PageSize: 5,
            countryList: [],
            loginSearch: {
                page: 1,
                page_size: 10,
                ali_user_id: ''
            },
            unboundData: {
                open_id: '',
                iot_id: ''
            },
            thridData: {}
        };
    },
    created() {
        this.getCountry();
    },
    watch: {
        activeName: function (n) {
            if (n == 'second') {
                if (this.baseInfo.status == 0) {
                    this.deviceInfo = [];
                } else {
                    this.getIotUserDeviceInfo();
                }
            }else if(n == 'third') {
                this.getThirdInfo();
            }
        }
    },
    activated() {
        this.activeName = 'first';
        this.ali_user_id = parseInt(this.$route.params.id);
        this.loginSearch.ali_user_id = parseInt(this.$route.params.id);
        this.getInfo();
    },
    methods: {
        getInfo() {
            this.api.getIotUserInfo({ ali_user_id: this.ali_user_id }).then(data => {
                this.baseInfo = data.data
                this.getIotUserLoginInfo();
            })

        },
        getIotUserLoginInfo() {
            this.api.getIotUserLoginInfo(this.loginSearch).then(data => {
                this.loginInfo = data.data.list || [];
                this.loginTotal = data.data.total;
            })
        },
        getIotUserDeviceInfo() {
            this.api.getIotUserDeviceInfo({ open_id: this.baseInfo.ali_open_id }).then(data => {
                this.deviceInfo = data.data ? data.data.result : [];
            })
        },
        getCountry() {
            this.api.getCountry({}).then(data => {
                this.countryList = data.data.country;
            })
        },
        paginationChange1(data) {
            this.loginSearch.page_size = data.page_size;
            this.loginSearch.page = data.page;
            this.getIotUserLoginInfo();
        },
        handleSizeChange(val) {
            // 改变每页显示的条数 
            this.PageSize = val
            // 注意：在改变每页显示的条数时，要将页码显示到第一页
            this.currentPage = 1
        },
        // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage = val
        },
        unboundConfirm(iotId) {
            this.$refs.Tip.show = true;
            this.unboundData.open_id = this.baseInfo.ali_open_id;
            this.unboundData.iot_id = iotId
        },
        unbound() {
            this.api.deviceUnbound(this.unboundData).then(data => {
                this.getIotUserDeviceInfo();
                this.$message.success('解绑成功!');
                this.$refs.Tip.show = false;
            })
        },
        goDetail(row, column, event) {
            if (window.h5sdk) {
                this.$router.push({ name: 'device-detail', params: { id: row.iotId }, query: { region: this.baseInfo.region, deviceName: row.deviceName } });
                return;
            }
            const page = this.$router.resolve({
                name: 'device-detail',
                params: {
                    id: row.iotId
                },
                query: {
                    region: this.baseInfo.region, deviceName: row.deviceName
                }
            });
            window.open(page.href, "_blank");
        },
        getThirdInfo() {
            this.api.getUserThirdInfo({user_id: this.ali_user_id}).then(data => {
                this.thridData = data.data[0] || {};
            })
        }
    }
});
</script>
<style lang="less" scoped>
.content_box {
    padding: 0;

}

.content {
    background: none;
    padding: 0;
    border-radius: 0;

    .top {
        .flexLayout(space-between);
        padding: 20px;
        background-color: @colorWhite;
    }

    .user {
        padding: 20px;
        min-height: calc(100% - 275px);

        .header {
            padding: 20px;
            margin-bottom: 20px;
            border-radius: 24px;
            background-color: white;

        }

        .main {
            padding: 20px;
            border-radius: 24px;
            background-color: white;
            min-height: 100%;

            .login_info {
                padding-top: 15px;
            }

            .font_size {
                // font-size: 14px;
                font-weight: bold;
            }

            .pagination {
                margin-bottom: 5px;
            }

            .pagination1 {
                padding: 10px 5px;
            }

            /deep/ .el-tabs__item {
                font-weight: 700;
                font-size: 16px;
            }
            /deep/ .el-tabs__nav-wrap::after{
                background-color: #EBEEF5;
                height: 1px;
            }
            /deep/ .el-tabs__active-bar{
                height: 1px;
            }
        }
    }

    /deep/ .el-descriptions-item__label:not(.is-bordered-label) {
        color: #868998;
    }
    /deep/.el-descriptions__body{
        color: #333;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/iot/user-manage/user-detail.vue